import { combineReducers } from 'redux'
import {
  createReducer,
  createNamedReducer,
} from 'helpers/ReducerUtil'
import reduceReducers from 'reduce-reducers'

import {
  UPDATE_REPORT,
  REMOVE_REPORT,
  ON_SELECT_FILTER,
  ON_UNSELECT_FILTER,
  UPDATE_QUERY,
  UPDATE_QUERY_CHANGES,
  UPDATE_QUERY_SOURCE,
  RESET_QUERY,
  CLEAR_FILTER,
  CLEAR_REPORTS,
  UPDATE_PROJECT_COUNTS_QUERY,
  TOGGLE_DASHBOARD_QUERY,
  ADD_SPECIFICATION_CHART,
  UPDATE_PROJECT_SPECIFICATION_QUERY,
  REMOVE_SPECIFICATION_CHART,
  UPDATE_AE_RESOURCES_QUERY,
  UPDATE_AE_REGIONS_QUERY,
  ProductHierarchyEnum,
  PartnerSiteEnum,
  AeRegionEnum,
  attributesEnum,
  chartsEnum,
  lifecyclesEnum,
  segmentsEnum,
  regionsEnum
} from './constants'

const updateReport = (prev, { report }) => {
  let newState = []

  // multi charts need special attention to update correct chart type
  if (report.type == chartsEnum.SPECIFICATION.value) {
    newState = prev.filter(prevReport => report.type !== prevReport.type || (report.parent !== prevReport.parent || report.value !== prevReport.value))
  } else if (report.type == chartsEnum.AE_RESOURCES.value) {
    newState = prev.filter(prevReport => report.type !== prevReport.type || report.segment !== prevReport.segment)
  } else {
    newState = prev.filter(prevReport => report.type !== prevReport.type)
  }

  if (report.uiType == 'stock') {
    report.data = report.data.map(types => {
      types.data = types.data.map(point => {
        return [Date.parse(point[0]), point[1]]
      })
      return types
    })
  }

  newState.push(report)
  return newState
}

const removeReport = (prev, { report }) => {
  const newState = [...prev]
  const index = newState.findIndex(prevReport => report === prevReport.type)
  if (index !== -1) {
    newState.splice(index, 1)
  }
  return newState
}

const clearReports = () => []

const selectFilter = (prev, { report }) => [...prev, report]

const unselectFilter = (prev, { report }) => {
  const newState = [...prev]
  const index = newState.findIndex(prevReport => report === prevReport)
  if (index !== -1) {
    newState.splice(index, 1)
  }
  return newState
}

const clearFilter = () => [chartsEnum.TOTAL_COUNTS.value]

const updateQuery = (prev, { query }) => query

const updateChanges = (prev, { changes }) => changes

const updateSource = (prev, { source }) => source

const resetQuery = () => []

const updateProjectCountsQuery = (prev, { query }) => [...query]

const updateAeResourcesQuery = (prev, { query }) => [...query]

const updateAeRegionsQuery = (prev, { query }) => [...query]

const updateProjectSpecificationQuery = (prev, { attr, index }) => {
  const newState = [...prev]
  newState[index] = attr
  return newState
}

const addSpecificationChart = (prev) => [...prev, attributesEnum.CLOCK.options[0]]

const removeSpecificationChart = (prev, { index }) => {
  const newState = [...prev]
  newState.splice(index, 1)
  return newState
}

const toggleDashboardQuery = (prev) => !prev

const reports = createReducer([], {
  [UPDATE_REPORT]: updateReport,
  [REMOVE_REPORT]: removeReport,
  [CLEAR_REPORTS]: clearReports
})

const filters = createReducer([chartsEnum.TOTAL_COUNTS.value], {
  [ON_UNSELECT_FILTER]: unselectFilter,
  [ON_SELECT_FILTER]: selectFilter,
  [CLEAR_FILTER]: clearFilter
})

const projectCountsQuery = createReducer([lifecyclesEnum.QUALIFICATION.value, lifecyclesEnum.DESIGN_REVIEW.value], {
  [UPDATE_PROJECT_COUNTS_QUERY]: updateProjectCountsQuery,
})

const aeResourcesQuery = createReducer([segmentsEnum.DESKTOP.value, segmentsEnum.NOTEBOOK.value, segmentsEnum.ENTERPRISE.value], {
  [UPDATE_AE_RESOURCES_QUERY]: updateAeResourcesQuery,
})

const aeRegionsQuery = createReducer([regionsEnum.SANTA_CLARA.value, regionsEnum.SEOUL.value, regionsEnum.SHANGHAI.value, regionsEnum.SHENZHEN.value, regionsEnum.TAIPEI.value], {
  [UPDATE_AE_REGIONS_QUERY]: updateAeRegionsQuery,
})

const projectSpecificationQuery = createReducer([chartsEnum.SPECIFICATION.default], {
  [UPDATE_PROJECT_SPECIFICATION_QUERY]: updateProjectSpecificationQuery,
  [ADD_SPECIFICATION_CHART]: addSpecificationChart,
  [REMOVE_SPECIFICATION_CHART]: removeSpecificationChart
})

const querySourceReducer = createReducer([], {
  [UPDATE_QUERY_SOURCE]: updateSource,
})

const queryReducer = createReducer([], {
  [UPDATE_QUERY]: updateQuery,
})

const queryChangesReducer = createReducer([], {
  [UPDATE_QUERY_CHANGES]: updateChanges,
})

const queryCrossReducer = createReducer([], {
  [RESET_QUERY]: resetQuery
})

const fullQueryReducer = (() => {
  const combinedQueries = { ...PartnerSiteEnum, ...ProductHierarchyEnum, ...AeRegionEnum }
  const reducers = Object.keys(combinedQueries)
    .reduce((result, key) => {
      const name = combinedQueries[key].label
      const reducer = combineReducers({
        source: createNamedReducer(name, querySourceReducer),
        query: reduceReducers(
          createNamedReducer(name, queryReducer),
          queryCrossReducer
        ),
        changes: reduceReducers(
          createNamedReducer(name, queryChangesReducer),
          queryCrossReducer
        )
      })
      return {
        ...result,
        [name]: reducer
      }
    }, {})
  return combineReducers(reducers)
})()

const chartQuery = combineReducers({
  projectCountsQuery,
  projectSpecificationQuery,
  aeResourcesQuery,
  aeRegionsQuery
})

const dashboardQueryUiReducer = createReducer(true, {
  [TOGGLE_DASHBOARD_QUERY]: toggleDashboardQuery
})

export default combineReducers({
  reports,
  filters,
  query: fullQueryReducer,
  chartQuery,
  dashboardQueryUI: dashboardQueryUiReducer
})
